/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  useRouteError,
  Navigate
} from 'react-router-dom';
import { BaseLayout } from '@link/metro-toei-pass/layouts';
import {
  LOCALE_LIST,
  DEFAULT_LOCALE
} from '@link/metro-toei-pass/constants/locale';

const Home = lazy(() => import('@link/metro-toei-pass/views/Home'));
const NotFound = lazy(() => import('@link/metro-toei-pass/views/NotFound'));

function RootErrorBoundary() {
  const error = useRouteError() as Error;

  if (error.message.includes('Failed to fetch dynamically imported module')) {
    location.reload();
  }
  return null;
}

const lazyView = (view: JSX.Element) => {
  return <Suspense fallback="Loading...">{view}</Suspense>;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      <Route
        path="/"
        element={<Navigate to={`/${DEFAULT_LOCALE}`} replace />}
      />

      {LOCALE_LIST.map(locale => (
        <Route key={locale} path={`/${locale}`} element={<BaseLayout />}>
          <Route index element={lazyView(<Home />)} />
          <Route path="*" element={lazyView(<NotFound />)} />
        </Route>
      ))}
    </Route>
  )
);

export default router;
